import Handlebars from "handlebars";

Handlebars.registerHelper("stringify", function (object) {
  return new Handlebars.SafeString(JSON.stringify(object, null, 2));
});
Handlebars.registerHelper("json", function (object) {
  return JSON.stringify(object);
});
